import React from "react";
import { Modal } from "react-bootstrap";

export const SocialModal = ({ show, handleClose }) => {
  return (
    <Modal size="lg" show={show} onHide={handleClose} centered>
      <Modal.Body>
        <div className="otpModalMain broadcastModal">
          <div className="closeIcon" onClick={handleClose}>
            <i className="fa-solid fa-xmark" />
          </div>

          {/* ── OLD SOCIAL MODAL — commented out ──
          <div className="socialModal">
            <h2 className="text-center mb-5">Join Our Free Crypto Updates</h2>
            <div className="row jc-center">
              <div className="col-12">
                <a href="https://whatsapp.com/channel/0029Vb6Z5GGEQIajENhVj20H?utm_source=igios&utm_campaign=wa_channels_url_xma&source_surface=26" target="_blank" className="whatsapp socialL">
                  <i className="fa-brands fa-whatsapp"></i>
                  <div className="text">Whatsapp Channel</div>
                </a>
              </div>
              <div className="col-12">
                <a className="insta socialL" href="https://www.instagram.com/channel/AbbEEsvUoFTOHaPf/ " target="_blank">
                  <i className="fa-brands fa-instagram"></i>
                  <div className="text">Instagram Channel</div>
                </a>
              </div>
              <div className="col-12">
                <a href="https://discord.gg/waqarzaka" target="_blank" className="discord socialL">
                  <i className="fa-brands fa-discord"></i>
                  <div className="text">Join Discord</div>
                </a>
              </div>
              <div className="col-12">
                <a href="https://t.me/waqarzaka" target="_blank" className="tele socialL">
                  <div className="text">Join Telegram</div>
                </a>
              </div>
              <div className="col-12">
                <a href="https://www.tiktok.com/@waqarzaka" target="_blank" className="tiktok socialL">
                  <i className="fa-brands fa-tiktok"></i>
                  <div className="text">Tiktok</div>
                </a>
              </div>
            </div>
            <div className="socialRow">
              <a href="https://www.messenger.com/channel/waqarzaka" target="_blank" className="ico"><img src={facebookIco} alt="facebook" /></a>
              <a href="https://twitter.com/zakawaqar" target="_blank" className="ico"><img src={twitterICo} alt="twitter" /></a>
              <a href="https://www.youtube.com/c/waqarzaka" target="_blank" className="ico"><img src={youtubeIco} alt="youtube" /></a>
            </div>
          </div>
          ── END OLD MODAL ── */}

          {/* ── NEW: Watch Waqar Zaka Trades ── */}
          <div style={s.wrap}>
            <h2 style={s.title}>Watch Waqar Zaka Trades</h2>
            <p style={s.subtitle}>Gold → US Stocks → Crypto Trading</p>

            {/* Telegram VPN notice */}
            <div style={s.vpnBox}>
              <p style={s.vpnTitle}>
                First Enable Telegram Without a VPN{" "}
                <span style={s.badge}>Pakistan Users Only</span>
              </p>
              <ol style={s.ol}>
                <li>
                  Open:{" "}
                  <a
                    href="https://mtpro.xyz/mtproto"
                    target="_blank"
                    rel="noreferrer"
                    style={s.link}
                  >
                    https://mtpro.xyz/mtproto
                  </a>
                </li>
                <li>Select any online proxy.</li>
                <li>Tap Connect.</li>
                <li>
                  Once you see <b>Proxy Connected</b>, Telegram is ready to use.
                </li>
              </ol>
            </div>

            <h3 style={s.sectionTitle}>Choose Your Preferred Exchange</h3>
            <p style={s.sectionSub}>
              Complete the steps below using <b>any one</b> of the supported
              exchanges to join the Waqar Zaka Elite Community.
            </p>

            {/* Option 3: MEXC */}
            <div style={s.optionBox}>
              <p style={s.optionTitle}>✅ Option 1: Join via MEXC Exchange</p>
              <p style={s.step}>
                <b>Step 1:</b> Create your MEXC account using the official
                referral link:
              </p>
              <a
                href="https://www.mexc.com/register?inviteCode=mexc-1YtSR"
                target="_blank"
                rel="noreferrer"
                style={s.linkBtn}
              >
                https://www.mexc.com/register?inviteCode=mexc-1YtSR
              </a>
              <p style={s.refCode}>
                Referral Code: <b>1YtSR</b>
              </p>
              <p style={s.step}>
                <b>Step 2:</b> Deposit at least <b>100 USDT</b> into your{" "}
                <b>Futures Wallet</b> (Spot Wallet deposits are not eligible).
              </p>
              <p style={s.step}>
                <b>Step 3:</b> Find your MEXC UID in your profile and verify it
                using the official Telegram bot:
              </p>
              <a
                href="https://t.me/WaqarZaka_Mexc_Bot"
                target="_blank"
                rel="noreferrer"
                style={s.teleBtn}
              >
                🤖 https://t.me/WaqarZaka_Mexc_Bot
              </a>
            </div>

            {/* Option 1: WEEX */}
            <div style={s.optionBox}>
              <p style={s.optionTitle}>✅ Option 2: Join via WEEX Exchange</p>
              <p style={s.step}>
                <b>Step 1:</b> Create your WEEX account using the official
                referral link:
              </p>
              <a
                href="https://support.weex.com/en/register?vipCode=z5je"
                target="_blank"
                rel="noreferrer"
                style={s.linkBtn}
              >
                https://support.weex.com/en/register?vipCode=z5je
              </a>
              <p style={s.refCode}>
                Referral Code: <b>z5je</b>
              </p>
              <p style={s.step}>
                <b>Step 2:</b> Deposit at least <b>100 USDT</b> into your WEEX
                wallet.
              </p>
              <p style={s.step}>
                <b>Step 3:</b> Locate your UID (available in your WEEX profile)
                and verify your account using our official Telegram bot:
              </p>
              <a
                href="https://t.me/WaqarZaka_WEEX_Elite_bot"
                target="_blank"
                rel="noreferrer"
                style={s.teleBtn}
              >
                🤖 https://t.me/WaqarZaka_WEEX_Elite_bot
              </a>
            </div>

            {/* Option 2: YUBIT */}
            <div style={s.optionBox}>
              <p style={s.optionTitle}>✅ Option 3: Join via YUBIT Exchange</p>
              <p style={s.step}>
                <b>Step 1:</b> Create your YUBIT account using the official
                referral link:
              </p>
              <a
                href="https://www.yubit.com/en-US/register?inviteCode=KVKZ"
                target="_blank"
                rel="noreferrer"
                style={s.linkBtn}
              >
                https://www.yubit.com/en-US/register?inviteCode=KVKZ
              </a>
              <p style={s.step}>
                <b>Step 2:</b> Deposit at least <b>100 USDT</b> into your YUBIT
                wallet.
              </p>
              <p style={s.step}>
                <b>Step 3:</b> Locate your UID (available in your YUBIT profile)
                and verify your account using our official Telegram bot:
              </p>
              <a
                href="https://t.me/waqarzaka_yubit_bot"
                target="_blank"
                rel="noreferrer"
                style={s.teleBtn}
              >
                🤖 https://t.me/waqarzaka_yubit_bot
              </a>
            </div>

            {/* Option 4: BYBIT */}
            <div style={s.optionBox}>
              <p style={s.optionTitle}>✅ Option 4: Join via BYBIT Exchange</p>
              <p style={s.step}>
                <b>Step 1:</b> Create your BYBIT account using the official
                referral link:
              </p>
              <a
                href="https://www.bybit.global/en/exclusive-user-campaign/?campaign_id=43928&affiliate_id=148029"
                target="_blank"
                rel="noreferrer"
                style={s.linkBtn}
              >
                https://www.bybit.global/en/exclusive-user-campaign/?campaign_id=43928&affiliate_id=148029
              </a>
              <p style={s.step}>
                <b>Step 2:</b> Deposit at least <b>100 USDT</b> into your BYBIT
                Wallet.
              </p>
              <p style={s.step}>
                <b>Step 3:</b> Find your BYBIT UID in your profile and verify it
                using the official Telegram bot:
              </p>
              <a
                href="https://t.me/wz_bybit_bot"
                target="_blank"
                rel="noreferrer"
                style={s.teleBtn}
              >
                🤖 https://t.me/wz_bybit_bot
              </a>
            </div>

            {/* Footer */}
            <div style={s.footer}>
              <p style={s.footerTitle}>Start Watching Waqar Zaka Trades</p>
              <p style={s.footerText}>
                Once your account is verified, you'll gain access to{" "}
                <b>Waqar Zaka Trades</b>, where you can follow trading
                opportunities across{" "}
                <b>Gold, US Stocks, and Cryptocurrency Markets</b>.
              </p>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

const s = {
  wrap: { padding: "10px 6px 20px" },
  title: {
    textAlign: "center",
    fontWeight: 700,
    fontSize: 24,
    marginBottom: 4,
  },
  subtitle: {
    textAlign: "center",
    color: "#7c3aed",
    fontWeight: 600,
    fontSize: 15,
    marginBottom: 20,
  },

  vpnBox: {
    background: "#fefce8",
    border: "1px solid #fde68a",
    borderRadius: 10,
    padding: "12px 16px",
    marginBottom: 20,
  },
  vpnTitle: { fontWeight: 600, fontSize: 14, marginBottom: 6 },
  badge: {
    background: "#fde68a",
    color: "#92400e",
    fontSize: 11,
    fontWeight: 600,
    borderRadius: 4,
    padding: "2px 7px",
    marginLeft: 6,
  },
  ol: { paddingLeft: 18, marginBottom: 0, fontSize: 13, lineHeight: 1.8 },

  sectionTitle: { fontWeight: 700, fontSize: 18, marginBottom: 4 },
  sectionSub: { fontSize: 13, color: "#555", marginBottom: 16 },

  optionBox: {
    border: "1px solid #e5e7eb",
    borderRadius: 12,
    padding: "14px 16px",
    marginBottom: 16,
  },
  optionTitle: {
    fontWeight: 700,
    fontSize: 15,
    color: "#1d1d1d",
    marginBottom: 10,
  },
  step: { fontSize: 13, marginBottom: 6, lineHeight: 1.6 },
  refCode: {
    fontSize: 13,
    color: "#444",
    marginBottom: 8,
    background: "#f3f4f6",
    display: "inline-block",
    padding: "3px 10px",
    borderRadius: 6,
  },

  linkBtn: {
    display: "block",
    wordBreak: "break-all",
    fontSize: 13,
    color: "#7c3aed",
    marginBottom: 10,
    textDecoration: "underline",
  },
  teleBtn: {
    display: "inline-block",
    background: "#0088cc",
    color: "#fff",
    borderRadius: 8,
    padding: "7px 14px",
    fontSize: 13,
    textDecoration: "none",
    marginBottom: 4,
    wordBreak: "break-all",
  },
  link: { color: "#7c3aed", fontSize: 13 },

  footer: {
    background: "#f0fdf4",
    border: "1px solid #bbf7d0",
    borderRadius: 10,
    padding: "14px 16px",
    marginTop: 8,
  },
  footerTitle: {
    fontWeight: 700,
    fontSize: 15,
    marginBottom: 6,
    color: "#166534",
  },
  footerText: {
    fontSize: 13,
    color: "#374151",
    marginBottom: 0,
    lineHeight: 1.7,
  },
};
